// This file exports everything defined in definitions.module.scss
// to make these styles usable in our components and themes
@import "./definitions.module.scss";

:export {
    // Breakpoints
    // @see style/muiTheme.js
    bpXs: $bp-xs;
    bpSm: $bp-sm;
    bpMd: $bp-md;
    bpLg: $bp-lg;
    bpXl: $bp-xl;

    // DIMENSIONS
    // ==========
    spacingUnitUnit: $spacing-unit-unit;
    spacingUnitUnitlessValue: $spacing-unit-unitless-value;
    spacingUnit: $spacing-unit;

    cardPadding: $card-padding;
    cardPaddingUnit: $card-padding-unit;
    cardPaddingUnitlessValue: $card-padding-unitless-value;

    modalMaxWidth: $modal-max-width;

    // COLORS
    // ======
    colorBlack: $color-black;
    colorBlue: $color-blue;
    colorBrandOrange: $color-brand-orange;
    colorDarkBlue: $color-dark-blue;
    colorDarkDarkBlue: $color-dark-dark-blue;
    colorDarkGray: $color-dark-gray;
    colorDarkDarkGray: $color-dark-dark-gray;
    colorDarkGrayBrown: $color-dark-gray-brown;
    colorDarkOrange: $color-dark-orange;
    colorWhite: $color-white;
    colorGray: $color-gray;
    colorRed: $color-red;

    colorGrayBrown: $color-gray-brown; // admin menu bg; etc
    colorGreen: $color-green;
    colorDarkGreen: $color-dark-green;
    colorLightGreen: $color-light-green;
    colorLightBlue: $color-light-blue;
    colorLightGray: $color-light-gray;
    colorLightLightBlue: $color-light-light-blue;
    colorLightLightGray: $color-light-light-gray;
    colorLightLightOrange: $color-light-light-orange;
    colorLightOrange: $color-light-orange;

    colorOffWhite: $color-off-white;
    colorOrange: $color-orange;
    colorPrimary: $color-primary;
    colorPrimaryDark: $color-primary-dark;
    colorPrimaryExtraContrast: $color-primary-extra-contrast; // even more contrast to use where a11y might be an issue
    colorPrimaryLight: $color-primary-light;

    colorSecondary: $color-secondary;
    colorSecondaryDark: $color-secondary-dark;
    colorSecondaryExtraContrast: $color-secondary-extra-contrast;
    colorSecondaryLight: $color-secondary-light;

    colorStatusDanger: $color-status-danger;
    colorStatusDangerBorder: $color-status-danger-border;
    colorStatusDangerContrast: $color-status-danger-contrast;

    colorStatusError: $color-status-error;
    colorStatusErrorBorder: $color-status-error-border;
    colorStatusErrorContrast: $color-status-error-contrast;
    colorStatusErrorDark: $color-status-error-dark;
    colorStatusErrorLight: $color-status-error-light;

    colorStatusInfo: $color-status-info;
    colorStatusInfoBorder: $color-status-info-border;
    colorStatusInfoContrast: $color-status-info-contrast;
    colorStatusInfoDark: $color-status-info-dark;
    colorStatusInfoLight: $color-status-info-light;

    colorStatusSuccess: $color-status-success;
    colorStatusSuccessBorder: $color-status-success-border;
    colorStatusSuccessContrast: $color-status-success-contrast;
    colorStatusSuccessDark: $color-status-success-dark;
    colorStatusSuccessLight: $color-status-success-light;

    colorStatusWarning: $color-status-warning;
    colorStatusWarningBorder: $color-status-warning-border;
    colorStatusWarningContrast: $color-status-warning-contrast;
    colorStatusWarningDark: $color-status-warning-dark;
    colorStatusWarningLight: $color-status-warning-light;

    colorDividerDefault: $color-divider-default;
    colorDividerLight: $color-divider-light;
    colorInputBackground: $color-input-background;
    colorInputBackgroundDisabled: $color-input-background-disabled;
    colorMenuHover: $color-menu-hover;

    paperPaddingUnitlessValue: $paper-padding-unitless-value; // @DEPRECATED
    paperPaddingUnit: $paper-padding-unit; // @DEPRECATED
    paperPadding: $paper-padding; // @DEPRECATED use "2" instead

    siteBreadcrumbColor: $site-breadcrumb-color;
    siteBreadcrumbColorLink: $site-breadcrumb-color-link;
    siteBreadcrumbColorLinkActive: $site-breadcrumb-color-link-active;
    siteBreadcrumbColorLinkHover: $site-breadcrumb-color-link-hover;
    siteMainMaxWidth: $site-main-max-width;
    siteMinWidth: $site-min-width;
    siteSidebarMenuWidth: $site-sidebar-menu-width; // "220px";

    txtColorDefault: $txt-color-default;
    txtColorH1: $txt-color-h1;
    txtColorH2: $txt-color-h2;
    txtColorH3: $txt-color-h3;
    txtColorH4: $txt-color-h4;
    txtColorH5: $txt-color-h5;
    txtColorH6: $txt-color-h6;
    txtColorP: $txt-color-p;
    txtColorLight: $txt-color-light;

    txtColorLink: $txt-color-link;
    txtColorMutedLink: $txt-color-muted-link;
    txtColorMutedLinkActive: $txt-color-muted-link-active;
    txtColorMutedLinkHover: $txt-color-muted-link-hover;
    txtAlertError: $txt-alert-error;
    txtAlertWarning: $txt-alert-warning;
    txtAlertInfo: $txt-alert-info;
    txtAlertSuccess: $txt-alert-success;

    // FONT FAMILY
    // ===========
    txtFontStackIdealSans: $txt-font-stack-ideal-sans;
    txtFontFamilyDefault: $txt-font-family-default;
    txtFontFamilyButtons: $txt-font-family-buttons;
    txtFontFamilyH1: $txt-font-family-h1;
    txtFontFamilyH2: $txt-font-family-h2;
    txtFontFamilyH3: $txt-font-family-h3;
    txtFontFamilyH4: $txt-font-family-h4;
    txtFontFamilyH6: $txt-font-family-h6;
    txtFontFamilyHeaders: $txt-font-family-headers;
    txtFontFamilyInputs: $txt-font-family-inputs;
    txtFontFamilyTableBody: $txt-font-family-table-body;
    txtFontFamilyTableHead: $txt-font-family-table-head;

    // FONT SIZE
    // =========
    txtFontSizeDefault: $txt-font-size-default;
    txtFontSizeDefaultBpLg: $txt-font-size-default-bp-lg;
    txtFontSizeDefaultBpMd: $txt-font-size-default-bp-md;
    txtFontSizeDefaultBpSm: $txt-font-size-default-bp-sm;
    txtFontSizeXxs: $txt-font-size-xxs;
    txtFontSizeXxsBpSm: $txt-font-size-xxs-bp-sm;
    txtFontSizeXxsBpMd: $txt-font-size-xxs-bp-md;
    txtFontSizeXxsBpLg: $txt-font-size-xxs-bp-lg;
    txtFontSizeXs: $txt-font-size-xs;
    txtFontSizeXsBpSm: $txt-font-size-xs-bp-sm;
    txtFontSizeXsBpMd: $txt-font-size-xs-bp-md;
    txtFontSizeXsBpLg: $txt-font-size-xs-bp-lg;
    txtFontSizeSm: $txt-font-size-sm;
    txtFontSizeSmBpSm: $txt-font-size-sm-bp-sm;
    txtFontSizeSmBpMd: $txt-font-size-sm-bp-md;
    txtFontSizeSmBpLg: $txt-font-size-sm-bp-lg;
    txtFontSizeLg: $txt-font-size-lg;
    txtFontSizeLgBpSm: $txt-font-size-lg-bp-sm;
    txtFontSizeLgBpMd: $txt-font-size-lg-bp-md;
    txtFontSizeLgBpLg: $txt-font-size-lg-bp-lg;
    txtFontSizeXl: $txt-font-size-xl;
    txtFontSizeXlBpSm: $txt-font-size-xl-bp-sm;
    txtFontSizeXlBpMd: $txt-font-size-xl-bp-md;
    txtFontSizeXlBpLg: $txt-font-size-xl-bp-lg;
    txtFontSizeXxl: $txt-font-size-xxl;
    txtFontSizeXxlBpSm: $txt-font-size-xxl-bp-sm;
    txtFontSizeXxlBpMd: $txt-font-size-xxl-bp-md;
    txtFontSizeXxlBpLg: $txt-font-size-xxl-bp-lg;
    txtFontSizeXxxl: $txt-font-size-xxxl;
    txtFontSizeXxxlBpSm: $txt-font-size-xxxl-bp-sm;
    txtFontSizeXxxlBpMd: $txt-font-size-xxxl-bp-md;
    txtFontSizeXxxlBpLg: $txt-font-size-xxxl-bp-lg;
    txtFontSizeButtons: $txt-font-size-buttons;
    txtFontSizeButtonsBpSm: $txt-font-size-buttons-bp-sm;
    txtFontSizeButtonsBpMd: $txt-font-size-buttons-bp-md;
    txtFontSizeButtonsBpLg: $txt-font-size-buttons-bp-lg;
    txtFontSizeButtonsSmall: $txt-font-size-buttons-small;
    txtFontSizeButtonsSmallBpSm: $txt-font-size-buttons-small-bp-sm;
    txtFontSizeButtonsSmallBpMd: $txt-font-size-buttons-small-bp-md;
    txtFontSizeButtonsSmallBpLg: $txt-font-size-buttons-small-bp-lg;
    txtFontSizeButtonsLarge: $txt-font-size-buttons-large;
    txtFontSizeInputs: $txt-font-size-inputs;
    txtFontSizeInputsBpSm: $txt-font-size-inputs-bp-sm;
    txtFontSizeInputsBpMd: $txt-font-size-inputs-bp-md;
    txtFontSizeInputsBpLg: $txt-font-size-inputs-bp-lg;
    txtFontSizeRatingSm: $txt-font-size-rating-sm;
    txtFontSizeRatingMd: $txt-font-size-rating-md;
    txtFontSizeRatingLg: $txt-font-size-rating-lg;
    txtFontSizeH1: $txt-font-size-h1;
    txtFontSizeH1BpSm: $txt-font-size-h1-bp-sm;
    txtFontSizeH1BpMd: $txt-font-size-h1-bp-md;
    txtFontSizeH1BpLg: $txt-font-size-h1-bp-lg;
    txtFontSizeH2: $txt-font-size-h2;
    txtFontSizeH2BpSm: $txt-font-size-h2-bp-sm;
    txtFontSizeH2BpMd: $txt-font-size-h2-bp-md;
    txtFontSizeH2BpLg: $txt-font-size-h2-bp-lg;
    txtFontSizeH3: $txt-font-size-h3;
    txtFontSizeH3BpSm: $txt-font-size-h3-bp-sm;
    txtFontSizeH3BpMd: $txt-font-size-h3-bp-md;
    txtFontSizeH3BpLg: $txt-font-size-h3-bp-lg;
    txtFontSizeH4: $txt-font-size-h4;
    txtFontSizeH4BpSm: $txt-font-size-h4-bp-sm;
    txtFontSizeH4BpMd: $txt-font-size-h4-bp-md;
    txtFontSizeH4BpLg: $txt-font-size-h4-bp-lg;
    txtFontSizeH5: $txt-font-size-h5;
    txtFontSizeH5BpSm: $txt-font-size-h5-bp-sm;
    txtFontSizeH5BpMd: $txt-font-size-h5-bp-md;
    txtFontSizeH5BpLg: $txt-font-size-h5-bp-lg;
    txtFontSizeH6: $txt-font-size-h6;
    txtFontSizeH6BpSm: $txt-font-size-h6-bp-sm;
    txtFontSizeH6BpMd: $txt-font-size-h6-bp-md;
    txtFontSizeH6BpLg: $txt-font-size-h6-bp-lg;
    txtFontSizeTableBody: $txt-font-size-table-body;
    txtFontSizeTableBodyBpSm: $txt-font-size-table-body-bp-sm;
    txtFontSizeTableBodyBpMd: $txt-font-size-table-body-bp-md;
    txtFontSizeTableBodyBpLg: $txt-font-size-table-body-bp-lg;
    txtFontSizeTableHead: $txt-font-size-table-head;
    txtFontSizeTableHeadBpSm: $txt-font-size-table-head-bp-sm;
    txtFontSizeTableHeadBpMd: $txt-font-size-table-head-bp-md;
    txtFontSizeTableHeadBpLg: $txt-font-size-table-head-bp-lg;

    // FONT VARIANT
    // ============
    txtFontVariantH1: $txt-font-variant-h1;
    txtFontVariantH2: $txt-font-variant-h2;
    txtFontVariantH3: $txt-font-variant-h3;
    txtFontVariantH4: $txt-font-variant-h4;
    txtFontVariantH5: $txt-font-variant-h5;
    txtFontVariantH6: $txt-font-variant-h6;

    // FONT WEIGHT
    // ===========
    txtFontWeightIdealSansLight: $txt-font-weight-ideal-sans-light;
    txtFontWeightIdealSansNormal: $txt-font-weight-ideal-sans-normal;
    txtFontWeightIdealSansSemibold: $txt-font-weight-ideal-sans-semibold;
    txtFontWeightIdealSansBold: $txt-font-weight-ideal-sans-bold;

    txtFontWeightDefaultLight: $txt-font-weight-default-light;
    txtFontWeightDefaultNormal: $txt-font-weight-default-normal;
    txtFontWeightDefaultSemibold: $txt-font-weight-default-semibold;
    txtFontWeightDefaultBold: $txt-font-weight-default-bold;

    txtFontWeightHeaders: $txt-font-weight-headers;
    txtFontWeightH1: $txt-font-weight-h1;
    txtFontWeightH2: $txt-font-weight-h2;
    txtFontWeightH3: $txt-font-weight-h3;
    txtFontWeightH4: $txt-font-weight-h4;
    txtFontWeightH5: $txt-font-weight-h5;
    txtFontWeightH6: $txt-font-weight-h6;

    txtFontWeightButtons: $txt-font-weight-buttons;
    txtFontWeightInputs: $txt-font-weight-inputs;
    txtFontWeightTableBody: $txt-font-weight-table-body;
    txtFontWeightTableHead: $txt-font-weight-table-head;

    // LETTER SPACING
    // ==============
    txtLetterSpacingButtons: $txt-letter-spacing-buttons;
    txtLetterSpacingHeaders: $txt-letter-spacing-headers;
    txtLetterSpacingH1: $txt-letter-spacing-h1;
    txtLetterSpacingH2: $txt-letter-spacing-h2;
    txtLetterSpacingH3: $txt-letter-spacing-h3;
    txtLetterSpacingH4: $txt-letter-spacing-h4;
    txtLetterSpacingH5: $txt-letter-spacing-h5;
    txtLetterSpacingH6: $txt-letter-spacing-h6;
    txtLetterSpacingBody: $txt-letter-spacing-body;
    txtLetterSpacingInputs: $txt-letter-spacing-inputs;
    txtLetterSpacingTableBody: $txt-letter-spacing-table-body;
    txtLetterSpacingTableHead: $txt-letter-spacing-table-head;

    // LINE HEIGHT
    // ===========
    txtLineHeightDefault: $txt-line-height-default;
    txtLineHeightButtons: $txt-line-height-buttons;
    txtLineHeightHeaders: $txt-line-height-headers;
    txtLineHeightH1: $txt-line-height-h1;
    txtLineHeightH2: $txt-line-height-h2;
    txtLineHeightH3: $txt-line-height-h3;
    txtLineHeightH4: $txt-line-height-h4;
    txtLineHeightH5: $txt-line-height-h5;
    txtLineHeightH6: $txt-line-height-h6;
    txtLineHeightP: $txt-line-height-p;
    txtLineHeightInputs: $txt-line-height-inputs;
    txtLineHeightTableBody: $txt-line-height-table-body;
    txtLineHeightTableHead: $txt-line-height-table-head;

    // BOTTOM MARGIN
    // =============
    txtMarginBottomH1: $txt-margin-bottom-h1;
    txtMarginBottomH2: $txt-margin-bottom-h2;
    txtMarginBottomH3: $txt-margin-bottom-h3;
    txtMarginBottomH4: $txt-margin-bottom-h4;
    txtMarginBottomH5: $txt-margin-bottom-h5;
    txtMarginBottomH6: $txt-margin-bottom-h6;
    txtMarginBottomP: $txt-margin-bottom-p;

    // TEXT TRANSFORMS
    // ---------------
    txtTextTransformH1: $txt-text-transform-h1;
    txtTextTransformH2: $txt-text-transform-h2;
    txtTextTransformH3: $txt-text-transform-h3;
    txtTextTransformH4: $txt-text-transform-h4;
    txtTextTransformH5: $txt-text-transform-h5;
    txtTextTransformH6: $txt-text-transform-h6;
}